document.addEventListener('DOMContentLoaded', function(){  
  //Consts
  const b = $('body'),
        s = $('.slider'),
        isTouchDevice = () => {
          return (('ontouchstart' in window) ||
                  (navigator.maxTouchPoints > 0) ||
                  (navigator.msMaxTouchPoints > 0));
        };
  
  //Functions
  function height(){
    document.documentElement.style.cssText = `
      --h:  ${window.innerHeight}px;
      --hs: ${window.innerHeight - $('footer').outerHeight(true)}px;
    `;
  }
  function hideIntro(){
    var top = $('main').offset().top;
    if($(window).scrollTop() != top){
      $('html,body').animate({
        scrollTop: top
      }, 'medium', 'easeInOutQuint', function(){
        $('#intro').remove();
        window.scrollTo(0,0);
      });    
    }else{
      $('#intro').remove();
      window.scrollTo(0,0);    
    }
  }
  function nextSlide(){
    if(!s.hasClass('transition')){
      s.addClass('transition').find('.slider-tracker').animate({
        'left': '-100%'
      }, 0, 'easeInOutQuint', function(){        
        s.find('.slide:first-child').parent().append(s.find('.slide:first-child'));  
        s.find('.slider-tracker').css('left', '0');
        s.removeClass('transition'); 
        if($('.slide:not(:first-child) video').length){
          $('.slide:not(:first-child) video')[0].pause();
        }
      });
      if($('.slide:first-child video').length){
        $('.slide:first-child video')[0].play();
      } 
      $('nav span').removeClass('active');
      $('nav span[data-pos="'+s.find('.slide:first-child').data('pos')+'"]').addClass('active');   
    }
  }
  function prevSlide(){
    if(!s.hasClass('transition')){ 
      s.find('.slide:last-child').parent().prepend(s.find('.slide:last-child'));
      s.addClass('transition').find('.slider-tracker').css('left', '-100%').animate({
        'left': '0'
      }, 0, 'easeInOutQuint', function(){          
        s.removeClass('transition');        
        if($('.slide:not(:first-child) video').length){
          $('.slide:not(:first-child) video')[0].pause();
        }
      });        
      if($('.slide:first-child video').length){
        $('.slide:first-child video')[0].play();
      }
      $('nav span').removeClass('active');
      $('nav span[data-pos="'+s.find('.slide:first-child').data('pos')+'"]').addClass('active');
    }
  }
  function checkKey(e){
    e = e || window.event;
    if(e.keyCode == '37' && s.length){
      prevSlide()
    }else if(e.keyCode == '39' && s.length){
      nextSlide()    
    }
  }
  function onLoadandResize(){
    height()
  }
  onLoadandResize()  
  
  //Device detection
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent || navigator.vendor || window.opera) ||
     isTouchDevice() == true){
    //If device
    b.addClass('mobile');    
    //Pseudoclass :active on devices
    document.addEventListener('touchstart', function(){}, {passive: true});
    //Resize Functions
    window.addEventListener('orientationchange', function(){
      setTimeout(function(){
        onLoadandResize()  
      }, 50);
    });
    //Slider
    if(s.length){
      let tsX = 0,
          teX = 0;
      const s = document.getElementsByClassName('slider')[0];
      s.addEventListener('touchstart', function(event){
        tsX = event.changedTouches[0].screenX;
      }, false);
      s.addEventListener('touchend', function(event){
        teX = event.changedTouches[0].screenX;  
        if(teX <= tsX && (tsX - teX > 50)){
          nextSlide()
        }
        if(teX >= tsX && (teX - tsX > 50)){
          prevSlide()
        }
      }, false);
    }
  }else{
    //if Desktop
    b.addClass('desktop');
    //Resize Functions
    window.onresize = function(){
      onLoadandResize()  
    }
    //Slider
    document.onkeydown = checkKey;
  }
  
  //Replace &nbsp;
  if($('.clear').length){
    $('.clear').html(function(i, html){
      return html.replace(/&nbsp;/g, ' ');
    });
    $('.clear div:not(.exclude)').each(function(){
      $(this).filter(function(){
        return $(this).text().trim().length == 0;
      }).remove();
    });
  }
  
  //Loader
  setTimeout(function(){
    $('#loader').fadeOut();
  }, 200);
  
  $(window).scroll(function(){
    if($(window).scrollTop() > window.innerHeight && $('#intro').length){
      $('#intro').remove();
      window.scrollTo(0,0);   
    }
  });
  $('#intro').click(function(){
    hideIntro()
  });
  
  //Menu
  $('#menu-trigger').click(function(){
  	$(this).toggleClass('active');
    $('menu').slideToggle('medium', 'easeInOutQuint')
  });
  
  //Subsections  
  $('.trigger').click(function(){
    var t = $(this),
        n = t.next('.collapsed');
    if(n.length){
      if($('.collapsed').not(n).is(':visible')){
        $('.collapsed:visible').slideUp('medium', 'easeInOutQuint', function(){
          $('.trigger').removeClass('active')
          t.addClass('active')
          n.slideDown('medium', 'easeInOutQuint');
        });
      }else{
        t.toggleClass('active')
        n.slideToggle('medium', 'easeInOutQuint');  
      }      
    }
  });
  
  //View mode
  $('#mode').click(function(){
    if(b.hasClass('view-list')){
      b.removeClass('view-list red');
      sessionStorage.setItem('view-list', false);
    }else{
      b.addClass('view-list red');
      sessionStorage.setItem('view-list', true);
    }    
  });
  if(sessionStorage.getItem('view-list') == 'true' && b.hasClass('template-collection')){
    b.addClass('view-list red');
  }
  
  //Sort
  $('#sort-list div').click(function(){
    var t = $(this),
        k = t.data('sort');
    t.toggleClass('active');
    $('.product:not([data-'+ k +'="null"])').sort(function(a, b){
      if(!t.hasClass('active')){
        $('#sort-img option.invert[value="'+k+'"]').prop('selected', true)
        return $(b).data(k) > $(a).data(k) ? 1 : -1;
      }else{
        $('#sort-img option:not(.invert)[value="'+k+'"]').prop('selected', true)
        return $(b).data(k) < $(a).data(k) ? 1 : -1;
      }
    }).prependTo('#products');
  });
  $('#sort-img select').change(function(){
    var t = $(this),
        k = t.val();
     $('#sort-list div').removeClass('active');
    $('.product:not([data-'+ k +'="null"])').sort(function(a, b){
      if(t.find('option:selected').is('.invert')){
        return $(b).data(k) > $(a).data(k) ? 1 : -1;
      }else{
        $('#sort-list div[data-sort="'+k+'"]').addClass('active');
        return $(b).data(k) < $(a).data(k) ? 1 : -1;
      }
    }).prependTo('#products');
  });
  
  //Dots
  $('nav span').click(function(e){
    var t = $(this),
        i = t.data('pos'),
        s = $('.slide[data-pos="'+i+'"]');
    $('.project-thumbnail-wrapper').removeClass('active');
    t.addClass('active').siblings().removeClass();
    $('.slider-tracker').prepend(s, s.nextAll());
  });
  
  //Lightbox
  $('.slide').click(function(){
  	$('#product-gallery').toggleClass('lightbox-active');
  });
  $('#close-lightbox').click(function(){
  	$('#product-gallery').removeClass('lightbox-active');
  });
  
  //Slider
  $('.next').click(function(){
   	nextSlide();
  });
  $('.prev').click(function(){
    prevSlide();
  });

  //Change Language
  if($('#weglot-switcher').length){
    Weglot.on('languageChanged', function(newLang, prevLang){
      console.log('ee')
      //checkLang();
      //Translations
      $('.translate').each(function(){
        var t = $(this),
            en = t.data('en'),
            es = t.data('es');       
        if($('html').attr('lang') == 'es'){
          if(t.is('input') || t.is('textarea')){
            t.attr('placeholder', es)        
          }else{
            t.html(es)
          }        
        }else{
          if(t.is('input') || t.is('textarea')){
            t.attr('placeholder', en)        
          }else{
            t.html(en)
          }        
        }
      });
    });
  }
  
  //Bid forms
  $('#bid-type').change(function(){    
    var t = $(this),
        v = t.val();    
    if(v != 'Presencial'){      
      if(!$('.form-collection').is(':visible')){
        $('.form-collection').slideDown('medium', 'easeInOutQuint')        
      }      
    }else{
      if($('.form-collection').is(':visible')){
        $('.form-collection').slideUp('medium', 'easeInOutQuint')        
      } 
    }
    if(v == 'Telefónica'){
      
      $('.bid').each(function(){        
        $(this).attr('data-es', 'Puja de emergencia')
         .attr('data-en', 'Emergency bid')
         .attr('placeholder', 'Puja de emergencia')  
         .prop('required', false)
      }); 
      
    }else if(v == 'Ausente'){  
      
      $('.bid').each(function(){      
      	var t = $(this),
            v = t.data('price');        
        t.attr('data-es', 'Puja mínima '+v)
         .attr('data-en', 'Minimum bid '+v)
         .attr('placeholder', 'Puja mínima '+v)        
       });  
      
    }  
    
    $('#form-bid input[type="checkbox"]').prop('checked', false);
    $('#form-bid .bid').val('').prop('required', false)
    
  });
  $('#form-bid input[type="checkbox"]').click(function(){
    var t = $(this),
        b = t.parent().next('.bid');
    if($('#bid-type').val() == 'Ausente'){
      if(t.prop('checked') == true){
      	b.prop('required', true)
      }else{
        b.prop('required', false)
      }
    }
    
  })
  
  //Lazy Loading
  var L = [].slice.call(document.querySelectorAll('.lazy')),
      P = [].slice.call(document.querySelectorAll('.picture > source'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let t = e.target;
          if(t.tagName == 'IMG'){
            t.src = t.dataset.src;
          	t.classList.remove('lazy');
          }
          if(t.tagName == 'VIDEO'){
            var P = t.play();
            if(P !== undefined){
              P.catch(error => {
                t.controls = true;
                t.classList.add('no-autoplay');
              });
            }
          	t.classList.remove('lazy');
          }
          if(t.parentElement.tagName == 'PICTURE'){
            t.srcset = t.dataset.srcset;
          	t.parentElement.classList.remove('picture');
          }
          o.unobserve(t);
        }
      });
    }, {rootMargin: '100% 0px 0px 0px'});
    L.forEach(function(t){
      o.observe(t);
    });
    P.forEach(function(t){
      o.observe(t);
    });
  }
  
});